import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import Hero from './components/Hero';
import IndustrySection from './components/IndustrySection';
import Navbar from './components/Navbar';
import { INDUSTRIES } from './constants';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans text-slate-900 selection:bg-brand-100 selection:text-brand-900">
      <Navbar />

      <main className="flex-grow">
        <Hero />

        <div id="services-container" className="scroll-mt-20">
          {INDUSTRIES.map((industry, index) => (
            <IndustrySection key={industry.id} industry={industry} index={index} />
          ))}
        </div>

        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default App;
